import React from 'react'
import '../emailcode/EmailCode.css'
import { Link } from 'react-router-dom'

const EmailCode = () => {
  return (
    <div className='email-code-section w-100 position-relative'>
        <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
        <div className='email-code-box d-flex flex-wrap align-content-center justify-content-center'>
            <h6 className='text-center'>Enter code sent to your email</h6>
            <div className='email-code-form w-100'>
                <form action="" className='d-flex align-items-center justify-content-between'>
                    <div class="input-box">
                        <input type="text" className="form-control text-center" maxLength="1" id="" placeholder="" />
                    </div>
                    <div class="input-box">
                        <input type="text" className="form-control text-center" maxLength="1" id="" placeholder="" />
                    </div>
                    <div class="input-box">
                        <input type="text" className="form-control text-center" maxLength="1" id="" placeholder="" />
                    </div>
                    <div class="input-box">
                        <input type="text" className="form-control text-center" maxLength="1" id="" placeholder="" />
                    </div>
                    <div class="input-box">
                        <input type="text" className="form-control text-center" maxLength="1" id="" placeholder="" />
                    </div>
                    <div class="input-box">
                        <input type="text" className="form-control text-center" maxLength="1" id="" placeholder="" />
                    </div>
                    <div class="input-box btn-box">
                        <Link rel='stylesheet' to="/create-password">
                            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.605 18.3076L20.4127 13.4999L15.605 8.69223" stroke="#787486" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.4122 13.5H6.95068" stroke="#787486" stroke-linecap="round" stroke-linejoin="round"/><path d="M26.1816 13.5C26.1816 6.59635 20.5853 1 13.6816 1C6.77808 1 1.18164 6.59635 1.18164 13.5C1.18164 20.4036 6.77808 26 13.6816 26C20.5853 26 26.1816 20.4036 26.1816 13.5Z" stroke="#787486" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </Link>
                    </div>
                </form>
                <p className='text-center'><Link rel='stylesheet' to="/">Resend code</Link></p>
            </div>
        </div>
    </div>
  )
}

export default EmailCode
